import React, { useState, useEffect } from 'react';
import { propertyAPI } from '../services/api';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PropertyCard from '../components/PropertyCard';
import { Input } from '../components/ui/input';
import { Search } from 'lucide-react';

const BENTO_PATTERN = [
  { cols: 'md:col-span-8', aspect: 'aspect-[4/3]' },
  { cols: 'md:col-span-4', aspect: 'aspect-square' },
  { cols: 'md:col-span-4', aspect: 'aspect-[3/4]' },
  { cols: 'md:col-span-8', aspect: 'aspect-video' },
  { cols: 'md:col-span-6', aspect: 'aspect-[4/3]' },
  { cols: 'md:col-span-6', aspect: 'aspect-[4/3]' },
];

const PropertyListing = () => {
  const [properties, setProperties] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    propertyAPI
      .list({ search: search.trim() || null })
      .then(setProperties)
      .catch(() => setProperties([]))
      .finally(() => setLoading(false));
  }, [search]);

  return (
    <div className="min-h-screen bg-background flex flex-col grain-overlay">
      <Navbar />

      <section className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pt-16 pb-8 lg:pt-24">
        <span className="block text-xs uppercase tracking-[0.24em] text-primary font-medium mb-4">
          The Collection
        </span>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-foreground">
          Every stay, in one place.
        </h1>
        <p className="text-muted-foreground mt-4 font-light max-w-2xl">
          Latest listings first — browse the full collection. Click any tile to
          be redirected to airbnb for details and booking.
        </p>
      </section>

      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pb-24 flex-1">
        <div className="mb-10 relative max-w-md">
          <Search className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder="Search stays..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="pl-11 h-12 bg-card border-border rounded-full text-foreground"
            data-testid="listing-search-input"
          />
        </div>

        {loading ? (
          <div className="grid grid-cols-12 gap-4 lg:gap-6">
            {BENTO_PATTERN.map((s, i) => (
              <div key={i} className={`col-span-12 ${s.cols} ${s.aspect} bg-muted rounded-3xl animate-pulse`} />
            ))}
          </div>
        ) : properties.length === 0 ? (
          <div className="text-center py-24 border border-dashed border-border rounded-3xl">
            <p className="text-muted-foreground">
              {search ? 'No properties match your search.' : 'No properties yet.'}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-12 gap-4 lg:gap-6">
            {properties.map((p, i) => {
              const slot = BENTO_PATTERN[i % BENTO_PATTERN.length];
              return (
                <div key={p.id} className={`col-span-12 ${slot.cols}`}>
                  <PropertyCard property={p} aspect={slot.aspect} />
                </div>
              );
            })}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default PropertyListing;
